import AbstractRestSystem from './AbstractRestSystem';
import axios from 'axios';
import AppError from 'util/AppError';

class RestSystem extends AbstractRestSystem{

  async authenticateSystemUser(parameterUserName,parameterPassword) {    
    const jwtSystemUserRequest =  {
      username: parameterUserName,
      password: parameterPassword,
    };        
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/authenticateSystemUser';        
    return await this.apiAuthenticatePost(url,jwtSystemUserRequest);
  }  

  async rebootCommandSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootCommandSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }

  async rebootConfigurationSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootConfigurationSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }

  async rebootCryptoSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootCryptoSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }
  
  async rebootDeviceSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootDeviceSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }  

  async rebootHandlersSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootHandlersSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }
  
  async rebootStaffUserHandlerSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootStaffUserHandlerSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }
  
  async rebootMerchantHandlerSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootMerchantHandlerSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }
  
  async rebootClientAccountTypeHandlerSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootClientAccountTypeHandlerSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }

  async rebootClientAccountHandlerSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootClientAccountHandlerSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }  

  async rebootEcosystemHandlerSystem(accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/administrationSystem/rebootEcosystemHandlerSystem';    
    return await this.apiFetchWithAccessToken(url,accessToken);
  }   
    


  async processCreateServiceOrderRequest(createServiceOrderRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/serviceOrderSystem/processCreateServiceOrderRequest';    
    return await this.apiPostWithAccessToken(url,accessToken,createServiceOrderRequest);
  }

  async processUpdateServiceOrderItemRequest(updateServiceOrderItemRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/serviceOrderSystem/processUpdateServiceOrderItemRequest';    
    return await this.apiPostWithAccessToken(url,accessToken,updateServiceOrderItemRequest);
  }  

  async addCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addCheckinProject';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }  

  async editCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editCheckinProject';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }    

  async removeCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeCheckinProject';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }  

  async addMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addMerchantAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }  

  async editMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editMerchantAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }    

  async removeMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeMerchantAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }
  

  async addMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addMerchantProduct';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }  

    async addMultiMerchantProduct(addMultiMerchantProductRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addMultiMerchantProduct';    
    return await this.apiPostWithAccessToken(url,accessToken,addMultiMerchantProductRequest);
  }

  async editMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editMerchantProduct';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }    

  async removeMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeMerchantProduct';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }    

  async addServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addServiceSequence';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }  

  async editServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editServiceSequence';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }    

  async removeServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeServiceSequence';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }    
  

  async addServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addServiceTable';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }  

  async editServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editServiceTable';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }    

  async removeServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeServiceTable';    
    return await this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }   
  
  async addCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addCheckinZone';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }  

  async editCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editCheckinZone';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }    

  async removeCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeCheckinZone';    
    return await this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }
  
  async addGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addGatewayPassage';    
    return await this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }  

  async editGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editGatewayPassage';    
    return await this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }    

  async removeGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeGatewayPassage';    
    return await this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }
  
  async addStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/addStaffUser';    
    return await this.apiPostWithAccessToken(url,accessToken,staffUser);
  }  

  async editStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/editStaffUser';    
    return await this.apiPostWithAccessToken(url,accessToken,staffUser);
  }    

  async removeStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/handlerSystem/removeStaffUser';    
    return await this.apiPostWithAccessToken(url,accessToken,staffUser);
  }  
  
  async addConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/addConvention';    
    return await this.apiPostWithAccessToken(url,accessToken,convention);
  }  

  async editConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/editConvention';    
    return await this.apiPostWithAccessToken(url,accessToken,convention);
  }    

  async removeConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/removeConvention';    
    return await this.apiPostWithAccessToken(url,accessToken,convention);
  }
  
  async addConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/addConference';    
    return await this.apiPostWithAccessToken(url,accessToken,conference);
  }  

  async editConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/editConference';    
    return await this.apiPostWithAccessToken(url,accessToken,conference);
  }    

  async removeConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/removeConference';    
    return await this.apiPostWithAccessToken(url,accessToken,conference);
  }
  
  async addExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/addExpositor';    
    return await this.apiPostWithAccessToken(url,accessToken,expositor);
  }  

  async editExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/editExpositor';    
    return await this.apiPostWithAccessToken(url,accessToken,expositor);
  }    

  async removeExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/removeExpositor';    
    return await this.apiPostWithAccessToken(url,accessToken,expositor);
  }  

  async processAssignUserInfoToStaffUserRequest(assignUserInfoToStaffUserRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/assignUserInfoToStaffUser';  
    console.log(">>>>>>>>>>url:" + url);  
    return await this.apiPostWithAccessToken(url,accessToken,assignUserInfoToStaffUserRequest);
  }  

  async processAssignDeviceToStaffUserRequest(assignDeviceToStaffUserRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/assignDeviceToStaffUser';  
    console.log(">>>>>>>>>>url:" + url);  
    return await this.apiPostWithAccessToken(url,accessToken,assignDeviceToStaffUserRequest);
  }
  
  async processReassignDeviceToStaffUserRequest(reassignDeviceToStaffUserRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/reassignDeviceToStaffUser';    
    return await this.apiPostWithAccessToken(url,accessToken,reassignDeviceToStaffUserRequest);
  }  

  async processAssignEcosystemDeviceToStaffUserRequest(assignEcosystemDeviceToStaffUserRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/assignEcosystemDeviceToStaffUser';  
    console.log(">>>>>>>>>>url:" + url);  
    return await this.apiPostWithAccessToken(url,accessToken,assignEcosystemDeviceToStaffUserRequest);
  }
  
  async processReassignEcosystemDeviceToStaffUserRequest(reassignEcosystemDeviceToStaffUserRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/reassignEcosystemDeviceToStaffUser';    
    return await this.apiPostWithAccessToken(url,accessToken,reassignEcosystemDeviceToStaffUserRequest);
  }    
  
  async processReturnDeviceRequest(returnDeviceRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/assignationSystem/returnDevice';    
    return await this.apiPostWithAccessToken(url,accessToken,returnDeviceRequest);
  }  
  /*Reportes*/
  async fetchClientAccountBalanceInfoReport(clientAccountBalanceInfoReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getClientAccountBalanceInfoReport';    
    return await this.apiPostWithAccessToken(url,accessToken,clientAccountBalanceInfoReportRequest);
  }    

  async fetchDepositSummaryReport(depositSummaryReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getDepositSummaryReport';    
    console.log("the url::::::" + url);
    console.log("the accessToken::::::" + accessToken);
    return await this.apiPostWithAccessToken(url,accessToken,depositSummaryReportRequest);
  }

  async fetchMerchantSummaryReport(merchantSummaryReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getMerchantSummaryReport';    
    return await this.apiPostWithAccessToken(url,accessToken,merchantSummaryReportRequest);
  }

  async fetchProductSummaryReport(productSummaryReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getProductSummaryReport';    
    return await this.apiPostWithAccessToken(url,accessToken,productSummaryReportRequest);
  }  

  async fetchGatewaySummaryReport(gatewaySummaryReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getGatewaySummaryReport';    
    return await this.apiPostWithAccessToken(url,accessToken,gatewaySummaryReportRequest);
  }

  async fetchStaffRecentExaminationReport(staffRecentExaminationReportRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/reportSystem/getStaffRecentExaminationReport';    
    return await this.apiPostWithAccessToken(url,accessToken,staffRecentExaminationReportRequest);
  }  

  /*Registro y Enroll ClientAccount*/
  async createEnrolledClientAccount(createEnrolledClientAccountRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/restSystem/createEnrolledClientAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,createEnrolledClientAccountRequest);
  }    

  async createClientAccount(createClientAccountRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/restSystem/createClientAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,createClientAccountRequest);
  }  

  async createConventionGuest(createConventionGuestRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/createConventionGuest';    
    return await this.apiPostWithAccessToken(url,accessToken,createConventionGuestRequest);
  }   

  async activateEnrolledClientAccount(activateEnrolledClientAccountRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/restSystem/activateEnrolledClientAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,activateEnrolledClientAccountRequest);
  }    

  async activateClientAccount(activateClientAccountRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/restSystem/activateClientAccount';    
    return await this.apiPostWithAccessToken(url,accessToken,activateClientAccountRequest);
  }
  
  async activateConventionGuest(activateConventionGuestRequest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/conventionSystem/activateConventionGuest';    
    return await this.apiPostWithAccessToken(url,accessToken,activateConventionGuestRequest);
  }  

  async uploadClientAccountFile(file,clientAccountFileConfig,accessToken) {    
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/fileUploadSystem/uploadClientAccountFile';  
    const formData = new FormData();
    formData.append('file', file);  
    formData.append('staffUserId', clientAccountFileConfig.staffUserId); 
    formData.append('checkinDeploymentId', clientAccountFileConfig.checkinDeploymentId); 
    formData.append('clientAccountTypeId', clientAccountFileConfig.clientAccountTypeId); 
    formData.append('accessTimeConfiguration', clientAccountFileConfig.accessTimeConfiguration); 
    formData.append('accessZoneConfiguration', clientAccountFileConfig.accessZoneConfiguration); 
    formData.append('creditBalance', clientAccountFileConfig.creditBalance); 
    formData.append('postpaymentBalance', clientAccountFileConfig.postpaymentBalance); 
    formData.append('giftBalance', clientAccountFileConfig.giftBalance); 
    formData.append('rewardsBalance', clientAccountFileConfig.rewardsBalance); 
    formData.append('activatedFlag', clientAccountFileConfig.activatedFlag); 


    const headers = {
      method: 'POST', 
      mode: 'cors', 
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Authorization': "Bearer " + accessToken,
      },
      origin: this.framework.getMemorySystem().getOrigin() ,
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    };

    const response = await axios.post(url,formData,headers)
    .catch(error => {
      throw new AppError("Server Error [500]","" +error,"" + error,"rest_system-8001","FileUploadException");
    });
    if(response !== null && response !== undefined) {
      if(response.status === 0 || response.status === 200) {
        return response;
      }
      else {             
        const serviceException = await response.json();
        if(serviceException.exceptionType !== undefined) {
          throw new AppError(serviceException.httpStatus,serviceException.messge,serviceException.developerMessage,serviceException.code,serviceException.exceptionType);
        }
        else {
          throw new AppError("Server Error [403]","Unknown Error during fileUpload","No stacktrace","rest_system-8003","UnknownException");
        } 
      }
    }
    throw new AppError("RestSystem Error [403]","Invalid Response error","No stacktrace","rest_system-8003","UnknownException");
  }   



}

export default RestSystem;